var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elfsight-app-82f48ce7-51fa-4d6e-b22b-c9e188eab0f6",attrs:{"data-elfsight-app-lazy":""}})}
var staticRenderFns = []

export { render, staticRenderFns }